import React from 'react';
import * as utils from '../../../utils';
import ChatHead from '../../ChatHead';

const ChatHeads = (props) => {
  const {
    activeConversation,
    changeConversationStatus,
    channels,
    conversations,
    deleteConversation,
    ignoreConversation,
    handleClick,
    screenSize,
    currentFilter,
  } = props;

  return conversations.map((conversation) => {
    const subjectLine = utils.getSubjectLineIfEmail(conversation, channels);
    const unreadCount = conversation.unread_count;
    const collapsed = ['xs', 'sm', 'md'].indexOf(screenSize) !== -1;

    return (
      <div key={conversation.id}>
        <ChatHead
          user_id={conversation.user_id}
          unreadCount={unreadCount}
          isActive={activeConversation === conversation.id}
          isClosed={conversation.status === 'closed'}
          conversation={conversation}
          lastMessageChannel={conversation.last_message_channel}
          lastMessageTimestamp={conversation.last_message_time}
          changeConversationStatus={changeConversationStatus}
          onClick={() => handleClick(conversation, unreadCount)}
          collapsed={collapsed}
          deleteConversation={deleteConversation}
          ignoreConversation={ignoreConversation}
          subjectLine={subjectLine}
          currentFilter={currentFilter}
        />
      </div>
    );
  });
};

export default ChatHeads;
